/** @jsx jsx */

import { css, jsx } from '@emotion/core';

import VersionHistory from 'app/developer-v3/components/VersionHistory';
import { filterAuditLogs } from 'app/developer-v3/pages/history/utils';
import { useQueryAuditLogs } from 'app/developer-v3/hooks';

const Styles = {
  root: css`
    ul {
      margin: 0;

      a {
        text-decoration: underline !important;
        font-weight: 400 !important;
      }
    }
  `,
};

type Props = {
  integrationId: number;
  isLoadingActiveProfile: boolean;
  isStaff: boolean;
  version: string;
};

function ColumnHistory({
  integrationId,
  isLoadingActiveProfile,
  isStaff,
  version,
}: Props) {
  const { data: auditLogs, isLoading: isLoadingAuditLogs } = useQueryAuditLogs({
    integrationId: String(integrationId),
    version,
  });

  const updatedAuditLogs = filterAuditLogs(auditLogs);

  return (
    <div css={Styles.root}>
      <VersionHistory
        isLoading={isLoadingActiveProfile || isLoadingAuditLogs}
        isStaff={isStaff}
        isTitleVisible={true}
        isVersionColumnVisible={false}
        logs={updatedAuditLogs}
      />
    </div>
  );
}

export default ColumnHistory;
